import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-contrib-ads';
import 'videojs-ima';
import "videojs-sprite-thumbnails"; 
import { ssaiAdParam } from '../../utils/utils';
export const VideoJS = (props) => {

  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  // const pauseRef = React.useRef(null);
  const { options, onReady, pauseVideo, isTrailer, poster, is_live, isRadioLive, isPlaylist , isOtt} = props;
   const appInfo = {
    projectDetails: projectInfo
  }
  const [isfullScreen,setIsFullScreen]= useState(false);
  const [controlColor, setControlColor] = useState();

  const location = useLocation()
  let uid = localStorage.getItem("gid");
  let user_id = localStorage.getItem("userId");
  if (user_id) {
    uid = user_id
  }
  videojs.Vhs.xhr.beforeRequest = function (options) {
    if (options?.uri.includes(".m3u8?id=")) {
      options.headers = {
        pubid: projectInfo?.projectConfig?.pubid,
        channelid: projectInfo?.projectConfig?.channelid,
        uid: uid,
        "access-token": accessToken
      };
    } else {


    }
    return options;
  };

  React.useEffect(() => {
    // Make sure Video.js player is only initialized once
    const videoElement = videoRef.current;
    if (!videoElement) return;
    const mergedOptions = { ...options, autoplay: isTrailer || is_live || isPlaylist || isOtt ? true : false, playsInline: isTrailer || is_live || isPlaylist || isOtt ? true : false };

    if (!playerRef.current) {
      const videoElement = videoRef.current;

      if (!videoElement) return;
      const player = playerRef.current = videojs(videoElement, mergedOptions, () => {
        onReady && onReady(player);
      });

      if(props?.liveData?.channel_id) {
        if (props?.liveData?.ssai_enabled) {
          ssaiAdParam(props?.liveData, appInfo).then((response) => {
            createSSAI(props?.liveData.ssai_link, videoElement, response, false);
          });
        } else {
          if (options?.sources) {
            player.src(options.sources);
          }
        }
      } else {
        if (options?.sources) {
          player.src(options.sources);
        }
      }

      if (props?.hoverThumbnail) {
        player.spriteThumbnails({
          url: props?.hoverThumbnail,
          width: 160,
          height: 90,
          interval: 1
        });
      }
      player.on('fullscreenchange', () => {
        setIsFullScreen(player.isFullscreen());
      });


      // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      const player = playerRef.current;
      player.autoplay(isTrailer || is_live ? true : false);
      if (options?.sources) {
        player.src(options.sources);
      }
    }
  }, [options, videoRef]);


  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;
    if (props?.adUrl) {
      var imaOptions = {
        adTagUrl: props?.adUrl
      };

      player.ima(imaOptions)

      player.on('error', () => {
        const error = player.error();
        if (error) {
          console.log(`Error Code: ${error.code} - ${error.message || "No message provided"}`);

          if (error.code === 4) {
            console.log("MEDIA_ERR_SRC_NOT_SUPPORTED: The video source is unsupported.");
          }
        }
      });
      player.on('ads-ad-started', () => {
        const videoElement = videoRef.current;
        try {
          document.getElementById('vjs_video_player_html5_api').pause()
        } catch (error) {
          console.log('error', error);

        }
      });

      player.on('play', () => {
        const posterImage = player.el().querySelector('.vjs-poster');
        if (posterImage && isRadioLive) {
          posterImage.style.display = 'block'; // Keep the poster visible
        }
      });
      player.on('ads-ad-ended', () => {

        player.play();
      });

      player.on('ima3-started', () => {
        player.pause(); 
      });

      player.on('ima3-complete', () => {
        player.play();
      });

    }

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;

      }
    };
    // playerRef.current.on("dispose",()=>{
    //   playerRef.current.pause()
    // })



  }, [videoRef]);
  useEffect(() => {
    const videoPlayerElements = document.querySelectorAll('.playerContainer, .videoContainer , .videoPlayer');
    
    if (videoRef.current && videoPlayerElements.length > 0) {
      if (isfullScreen) {
        videoRef.current.classList.add('video-rotate');
        videoPlayerElements.forEach((element) => element.classList.add('rotate-fullscreen'));
      } else {
        videoRef.current.classList.remove('video-rotate');
        videoPlayerElements.forEach((element) => element.classList.remove('rotate-fullscreen'));
      }
    }
  }, [isfullScreen]); 

   useEffect(() => {
      setControlColor(projectInfo?.projectConfig?.config?.BUTTON_COLOR || '#fff');
    }, [projectInfo]);

   function createSSAI(url, videoElem, adsParams, clearFlag) {


    let eachSecondInterval;
    let refreshInterval;
    if (clearFlag === false) {

      sessionCreation(url);

      var arr = url.split("/");
      var result = arr[0] + "//" + arr[2]
      var domainOfUrl = result;



      var previousTime = 0;
      var beaconTime = [];
      var trackingUrl = domainOfUrl;
      var beaconData = []
      var whereYouAt = 0;
      eachSecondInterval = setInterval(eachSecond, 1000);
      function isInArray(value, array) {
        return array.indexOf(value);
      }

      function eachSecond() {


        whereYouAt = whereYouAt + 1;
        whereYouAt = Math.round(whereYouAt)



        if (whereYouAt != previousTime) {
          previousTime = whereYouAt;

          if (beaconTime.length > 0) {

            if (isInArray(whereYouAt, beaconTime) > -1) {

              var temp = beaconData[isInArray(whereYouAt, beaconTime)].beaconUrls;
              for (var i = 0; i < temp.length; i++) {

                callAdTrackingUrl(temp[i])
              }
            }
          }

        }
      }


      function callAPI(url) {

        var request = new XMLHttpRequest();
        request.onreadystatechange = function () {
          if (request.readyState == 4 && request.status == 200) {


            var trackingData = JSON.parse(request.responseText);

            var avails = trackingData.avails;



            for (let k = 0; k < avails.length; k++) {


              var avail = avails[k];

              var ads = avail.ads;


              for (let j = 0; j < ads.length; j++) {

                var trackingEvents = ads[j].trackingEvents;

                for (k = 0; k < trackingEvents.length; k++) {

                  var trackingEvent = trackingEvents[k]



                  if (trackingEvent && trackingEvent.eventType) {
                    var eventType = trackingEvent.eventType;
                    if (eventType == "start" || eventType == "firstQuartile" || eventType == "firstQuartile" || eventType == "midpoint" || eventType == "impression") {
                      beaconTime.push(Math.round(trackingEvent.startTimeInSeconds))
                      beaconData.push(trackingEvent)


                    }
                  }

                }



              }




            }


          } else if (request.status == 502) {

            beaconTime = [];

          }

        }
        request.open("GET", url);
        request.send(null);
      }

      function sessionCreation(theUrl) {

        var data = JSON.stringify(adsParams);

        var xhr = new XMLHttpRequest();


        xhr.addEventListener("readystatechange", function () {
          if (this.readyState === 4) {
            var jsonResult = JSON.parse(this.responseText)


            // const player = videojs(videoElem);

            const player = playerRef.current = videojs(videoElem, options, () => {
              onReady && onReady(player);
            });

            if (jsonResult) {
              player.src({
                src: domainOfUrl + jsonResult.manifestUrl,
                type: 'application/x-mpegURL',
              });
              trackingUrl = trackingUrl + jsonResult.trackingUrl;
              refreshInterval = setInterval(refresh, 10000);
            }




          }
        });

        xhr.open("POST", theUrl);
        xhr.setRequestHeader("content-type", "application/json");


        xhr.send(data);


      }

      function refresh() {
        callAPI(trackingUrl);
      }



      function callAdTrackingUrl(theUrl) {


        var i = document.createElement("img");
        i.src = theUrl;



      }
    } else if (clearFlag === true) {
      clearTimeout(eachSecondInterval)
      clearTimeout(refreshInterval)
    }




  } 

  return (
     <div data-vjs-player>
      <style>{`
        .video-js .vjs-play-progress {
          background-color: ${controlColor};
        }
        .vjs-control:hover {
          color: ${controlColor}; 
        }
        .vjs-volume-level {
          background-color: ${controlColor} !important;
        }
        .vjs-control:hover > .vjs-icon-placeholder,
        .vjs-control:hover > .vjs-icon-play,
        .vjs-control:hover > .vjs-icon-pause,
        .vjs-control:hover > .vjs-icon-volume-high,
        .vjs-control:hover > .vjs-icon-captions,
        .vjs-control:hover > .vjs-icon-fullscreen-enter,
        .vjs-control:hover > .vjs-icon-fullscreen-exit {
          background: ${controlColor}; 
          color: ${controlColor}; 
        }
      `}</style>
      <video ref={videoRef} id='vjs_video_player' className='video-js vjs-big-play-centered' poster={poster} >
        {
          props?.closedCaptions?.map((item, index) => (
            <track key={index} kind='captions' src={item?.closed_caption_url} srclang={item?.short_code} label={item?.language_name} default={projectInfo?.projectConfig?.config?.DEFAULT_CAPTIONS_ON == "true" ? true : false} />
          ))
        }
        {
          props?.subtitles?.map((item, index) => (
            <track key={index} kind='captions' src={item?.subtitle_url} srclang={item?.short_code} label={item?.language_name} default={projectInfo?.projectConfig?.config?.DEFAULT_CAPTIONS_ON == "true" ? true : false} />
          ))
        }

      </video>
    </div>
  );
}

export default VideoJS;